module.exports = __webpack_public_path__ + "img/formador-50.3594265e.png";